import { render } from "./IconText.vue?vue&type=template&id=3ac7390e"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__